import type { KeyboardEvent } from 'react';

export const getDisclosureToggleProps = (isExpanded: boolean, toggle: () => void, disabled = false) => ({
  role: 'button' as const,
  tabIndex: disabled ? -1 : 0,
  'aria-expanded': isExpanded,
  'aria-disabled': disabled || undefined,
  onClick: toggle,
  onKeyDown: (event: KeyboardEvent<HTMLElement>) => {
    if (event.key !== 'Enter' && event.key !== ' ') {
      return;
    }
    event.preventDefault();
    toggle();
  }
});
